import s from '../DietPlanBuilder.module.css';
import { copy } from '../../copy';
import { MACRO_LABEL, type MacroDrift } from '../../lib/nutrition';

export type MealTargetsBannerProps = {
  shareSum: number;
  macroDrifts: MacroDrift[];
  onScaleShares: () => void;
};

export function MealTargetsBanner({ shareSum, macroDrifts, onScaleShares }: MealTargetsBannerProps) {
  const showShare = shareSum !== 100;
  const showMacro = macroDrifts.length > 0;
  if (!showShare && !showMacro) return null;

  const sharePct = Math.round(shareSum * 10) / 10;
  const macroParts = macroDrifts.map(d =>
    `${Math.round(d.actual)} g ${MACRO_LABEL[d.key]} (goal ${d.goal})`,
  );

  return (
    <div className={s.mealTargetsBannerStack}>
      {showMacro ? (
        <div className={s.mealTargetsBanner} data-variant="macro" role="status">
          <p className={s.mealTargetsBannerText}>{copy.targets.macroTotalsGap(macroParts)}</p>
        </div>
      ) : null}
      {showShare ? (
        <div className={s.mealTargetsBanner} data-variant="share" role="status">
          <p className={s.mealTargetsBannerText}>{copy.targets.shareNot100(sharePct)}</p>
          <button type="button" className={s.mealTargetsBannerBtn} onClick={onScaleShares}>
            {copy.targets.scaleSharesStandard}
          </button>
        </div>
      ) : null}
    </div>
  );
}
